import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
export function Testimonials() {
  const testimonials = [{
    quote: "Alex's insights from Waydev completely changed how we measure engineering success. We moved away from vanity metrics and focused on cycle time, which directly improved our time-to-market.",
    name: 'Sarah Jenkins',
    title: 'VP of Engineering',
    company: 'Series C FinTech'
  }, {
    quote: 'The organizational design frameworks Alex provided helped us scale from 30 to 100 engineers without losing our culture or slowing down our release cadence.',
    name: 'David Chen',
    title: 'CTO & Co-founder',
    company: 'Enterprise SaaS'
  }];
  return <section className="py-24 md:py-32 bg-surface/30 border-y border-border/50" data-id="element-237">
      <div className="container mx-auto px-6 md:px-12" data-id="element-238">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24" data-id="element-239">
          {testimonials.map((t, index) => <SectionReveal key={index} delay={index * 0.2} data-id="element-240">
              <div className="relative" data-id="element-241">
                <span className="absolute -top-10 -left-6 text-8xl text-surface font-serif leading-none select-none" data-id="element-242">
                  "
                </span>
                <blockquote className="relative z-10" data-id="element-243">
                  <p className="font-serif text-2xl md:text-3xl leading-relaxed mb-8 text-balance" data-id="element-244">
                    {t.quote}
                  </p>
                  <footer data-id="element-245">
                    <p className="font-medium text-primary" data-id="element-246">{t.name}</p>
                    <p className="text-sm text-secondary" data-id="element-247">
                      {t.title}, {t.company}
                    </p>
                  </footer>
                </blockquote>
              </div>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}